
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movies",
      function () {
        return require("private-next-pages/movies/index.tsx");
      }
    ]);
  